<template>
  <div>
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading">

      <div class="distribution-content" v-if="description.length>0">
        <div v-html="description"></div>
      </div>

      <div class="distribution-content-noDate" v-if="description.length==0">
        <div>暂无数据</div>
      </div>

    </div>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { storeName } from '@/router/Constant'
  import { getDistributionRule} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,PullRefresh,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';

  export default {
    name: "distributionRule",
    data(){
      return{
        showLoading:true,
        description:'',
        token:getStore("externalLoginKey"),
      }
    },
    mounted:function () {
      this.initData()
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      [PullRefresh.name]: PullRefresh,
      loading,
      [Dialog.Component.name]: Dialog.Component,
    },

    methods:{

      async initData() {
        this.getRule()
      },

      getRule:function(){
        let param = {
          externalLoginKey: this.token,
        }
        getDistributionRule(param)
          .then(res => {
            this.showLoading = false
            console.log(res);
            if(!res._ERROR_MESSAGE_){
              this.description = res.content
            }else{
              Toast({message:res._ERROR_MESSAGE_})
            }
          })
          .catch(err => {
            console.log(err);
          });

      },
    }
  }
</script>

<style scoped>

  .distribution-content{
    width:21.4375rem;
    margin: 0 auto;
    /*padding-top :3rem;*/
  }
  .distribution-content-noDate{
    width:100%;
    text-align: center;
    padding-top: 3rem;
    font-size: 1rem;
    color:#333;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/mine/distributionRule.vue